<template>
    <div class="field is-horizontal">
        <div class="field-label">
            <label class="label">Remarks:</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control">
                    <input v-model="getCurrentRemarks" class="input" type="text" placeholder="Group remarks.">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            getCurrentRemarks: {
                get() {
                    return this.$store.getters.getSelectedGroup.remarks
                },
                set(value) {
                    this.$store.dispatch('changeSelectedGroupFieldValue', {field: 'remarks', value: value})
                }
            }
        }
    }

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auctions/Advance/BiddingModal/Inputs/GroupRemarksInput.vue